import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export const actionHandlers = {
    'occurrences.create': {
        describe: op => i18n.t("Ajout d'une action sur {{count}} élément", { count: op.payload.creation.elements.length }),
        buildRequest: async (op) => ({ request: { method: 'post', url: `${BACKEND_ENDPOINT}actions/occurrences`, data: op.payload.creation } }),
        // Une occurrence par élément : la locale est reliée à celle que l'API a créée, ou à celle qui existait déjà (même action à
        // faire le même jour, renvoyée dans « existing »)
        onSuccess: async (op, response, context) => {
            const byElement = new Map([...(response.data?.occurrences || []), ...(response.data?.existing || [])].map(occurrence => [occurrence.elementId, occurrence]));
            const mapped = [];
            for (const [elementId, localId] of Object.entries(op.payload.localIds)) {
                const serverOccurrence = byElement.get(elementId);
                if (!serverOccurrence) continue;
                await context.idMap.set('occurrence', localId, serverOccurrence.id);
                mapped.push([localId, serverOccurrence.id]);
            }
            return { created: response.data?.occurrences || [], existing: response.data?.existing || [], localIds: Object.values(op.payload.localIds), mapped };
        }
    },
    'occurrences.update': {
        describe: op => i18n.t("Mise à jour de {{count}} occurrence d'action", { count: op.payload.occurrences.length }),
        // Occurrence créée sur l'appareil : id du serveur ; encore inconnu (création écartée ou abandonnée), elle est retirée de l'envoi
        buildRequest: async (op, context) => {
            const occurrences = [];
            for (const occurrence of op.payload.occurrences) {
                const id = await context.idMap.resolve('occurrence', occurrence.id);
                if (id !== undefined) occurrences.push({ ...occurrence, id });
            }
            if (!occurrences.length) return { discard: true, reason: 'deleted_on_server' };
            const { fields, deathCauseId, cancelPendingRecurrences } = op.payload;
            return {
                request: {
                    method: 'put',
                    url: `${BACKEND_ENDPOINT}actions/occurrences?projectId=${op.projectId}&deathCauseId=${deathCauseId || 0}&cancelPendingRecurrences=${cancelPendingRecurrences ? 'true' : 'false'}${fields ? `&fields=${fields.join(',')}` : ''}`,
                    data: occurrences
                }
            };
        },
        onSuccess: async (op, response) => ({ occurrences: response.data?.occurrences || [], histories: response.data?.histories || [], trees: response.data?.trees || [] }),
        // Plus aucune de ces occurrences en base (supprimées ailleurs)
        isAlreadyDone: (error) => error?.response?.status === 404
    },
    // L'API ignore les occurrences absentes ou déjà validées : naturellement rejouable
    'occurrences.delete': {
        describe: op => i18n.t("Suppression de {{count}} occurrence d'action", { count: op.payload.ids.length }),
        buildRequest: async (op, context) => {
            const ids = [];
            for (const id of op.payload.ids) {
                const serverId = await context.idMap.resolve('occurrence', id);
                if (serverId !== undefined) ids.push(serverId);
            }
            if (!ids.length) return { discard: true, reason: 'deleted_on_server' };
            return { request: { method: 'delete', url: `${BACKEND_ENDPOINT}actions/occurrences?projectId=${op.projectId}`, data: { ids } } };
        },
        onSuccess: async (op, response) => ({ removedIds: response.data?.removedIds || [] })
    },
    'series.addElements': {
        describe: op => i18n.t("Liaison de {{count}} élément à une action récurrente", { count: op.payload.elements.length }),
        buildRequest: async (op) => ({ request: { method: 'post', url: `${BACKEND_ENDPOINT}actions/series/elements`, data: { seriesId: op.payload.seriesId, projectId: op.projectId, elements: op.payload.elements } } }),
        onSuccess: async (op, response) => ({ series: response.data?.series, occurrences: response.data?.occurrences || [] }),
        // Série supprimée ailleurs
        isAlreadyDone: (error) => error?.response?.status === 404
    },
    'series.removeElements': {
        describe: op => i18n.t("Retrait de {{count}} élément d'une action récurrente", { count: op.payload.elementIds.length }),
        buildRequest: async (op) => ({ request: { method: 'delete', url: `${BACKEND_ENDPOINT}actions/series/elements`, data: { seriesId: op.payload.seriesId, projectId: op.projectId, elementIds: op.payload.elementIds } } }),
        onSuccess: async (op, response) => ({ series: response.data?.series, removedIds: response.data?.removedIds || [] }),
        isAlreadyDone: (error) => error?.response?.status === 404
    }
};
